/* global google */
async function initLocationFinder() {
	/* eslint-disable no-console */
	// console.log('loc-finder-script-loaded');
	let markers = [];
	const zipCodeMap = {};
	const zipCodes = window.zipCodesGlobal;
	const cityZipMap = window.cityZipMapGlobal;

	let map;
	const mapStyles = [
		{
			featureType: 'all',
			elementType: 'geometry.fill',
			stylers: [
				{
					weight: '2.00',
				},
			],
		},
		{
			featureType: 'all',
			elementType: 'geometry.stroke',
			stylers: [
				{
					color: '#9c9c9c',
				},
			],
		},
		{
			featureType: 'all',
			elementType: 'labels.text',
			stylers: [
				{
					visibility: 'on',
				},
			],
		},
		{
			featureType: 'landscape',
			elementType: 'all',
			stylers: [
				{
					color: '#f2f2f2',
				},
			],
		},
		{
			featureType: 'landscape',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#ffffff',
				},
			],
		},
		{
			featureType: 'landscape.man_made',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#ffffff',
				},
			],
		},
		{
			featureType: 'poi',
			elementType: 'all',
			stylers: [
				{
					visibility: 'off',
				},
			],
		},
		{
			featureType: 'road',
			elementType: 'all',
			stylers: [
				{
					saturation: -100,
				},
				{
					lightness: 45,
				},
			],
		},
		{
			featureType: 'road',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#eeeeee',
				},
			],
		},
		{
			featureType: 'road',
			elementType: 'labels.text.fill',
			stylers: [
				{
					color: '#7b7b7b',
				},
			],
		},
		{
			featureType: 'road',
			elementType: 'labels.text.stroke',
			stylers: [
				{
					color: '#ffffff',
				},
			],
		},
		{
			featureType: 'road.highway',
			elementType: 'all',
			stylers: [
				{
					visibility: 'simplified',
				},
			],
		},
		{
			featureType: 'road.arterial',
			elementType: 'labels.icon',
			stylers: [
				{
					visibility: 'off',
				},
			],
		},
		{
			featureType: 'transit',
			elementType: 'all',
			stylers: [
				{
					visibility: 'off',
				},
			],
		},
		{
			featureType: 'water',
			elementType: 'all',
			stylers: [
				{
					color: '#46bcec',
				},
				{
					visibility: 'on',
				},
			],
		},
		{
			featureType: 'water',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#c8d7d4',
				},
			],
		},
		{
			featureType: 'water',
			elementType: 'labels.text.fill',
			stylers: [
				{
					color: '#070707',
				},
			],
		},
		{
			featureType: 'water',
			elementType: 'labels.text.stroke',
			stylers: [
				{
					color: '#ffffff',
				},
			],
		},
	];

	function decodeHtml(html) {
		const txt = document.createElement('textarea');
		txt.innerHTML = html;
		return txt.value;
	}

	// Helper function to update info card visibility
	const updateInfoCardVisibility = (matchingZipCodes, type) => {
		let uniqueTitles;
		let uniqueZipCodes;

		if (type === 'titles') {
			uniqueTitles = [...new Set(matchingZipCodes.map(decodeHtml))];
		} else {
			uniqueZipCodes = [...new Set(matchingZipCodes)];
		}
		//console.log('unique titles: ', uniqueTitles);
		const infoCards = document.querySelectorAll('.info-card');
		if (infoCards.length > 0) {
			infoCards.forEach((card) => {
				const cardZip = card.getAttribute('data-zip');
				const cardTitle = card.getAttribute('data-title');
				//console.log('card title', cardTitle);
				//console.log('testing code unique ' + cardZip, uniqueZipCodes);
				if (type === 'titles') {
					if (
						uniqueTitles !== undefined &&
						uniqueTitles.includes(cardTitle)
					) {
						card.classList.remove('hide-location');
					} else {
						card.classList.add('hide-location');
					}
				} else if (type === 'zip') {
					if (
						uniqueZipCodes !== undefined &&
						uniqueZipCodes.includes(cardZip)
					) {
						card.classList.remove('hide-location');
					} else {
						card.classList.add('hide-location');
					}
				}
			});
		}
	};

	// Create a map for quick lookup
	zipCodes.forEach((item) => {
		zipCodeMap[item.zip] = item;
	});

	const venueZipCodes = zipCodes.map((card) => {
		return card.zip;
	});

	// Check if venue zip codes match any existing zip codes and add markers
	venueZipCodes.forEach((venueZip) => {
		if (zipCodeMap[venueZip]) {
			const { lat, lng } = zipCodeMap[venueZip]; // Get lat/lng from zipCodeMap
			const title = zipCodeMap[venueZip].title; // Get title from zipCodeMap
			// Debugging output to check lat/lng
			// console.log(
			// 	`Adding marker for zip: ${venueZip}, lat: ${lat}, lng: ${lng}`
			// );

			// Ensure lat and lng are numbers
			if (typeof lat === 'number' && typeof lng === 'number') {
				addMarker(venueZip, lat, lng, title); // Call addMarker with zip, lat, and lng
			} else {
				console.error(
					`Invalid lat/lng for zip ${venueZip}: lat: ${lat}, lng: ${lng}`
				);
			}
		} else {
			console.warn(`No data found for zip ${venueZip}`);
		}
	});

	async function initMap() {
		map = new google.maps.Map(document.getElementById('map'), {
			center: { lat: 37.774929, lng: -122.419418 },
			zoom: 8,
			styles: mapStyles, // Apply custom styles
		});
		const venuesZipCodes = zipCodes.map((card) => {
			return card.zip;
		});
		// console.log('venuesZipCodes ==>> ', venuesZipCodes);
		const venueZipSet = new Set(venuesZipCodes);

		const bounds = new google.maps.LatLngBounds();
		zipCodes.forEach((location) => {
			if (venueZipSet.has(location.zip)) {
				addMarker(
					location.zip,
					location.lat,
					location.lng,
					location.title
				); // Pass lat and lng separately

				bounds.extend(
					new google.maps.LatLng(location.lat, location.lng)
				);
			}
		});

		// Fit the map to the bounds of all markers
		if (markers.length > 0) {
			map.fitBounds(bounds); // Fit the map only if there are markers
		}

		// Handle the search button click
		document
			.getElementById('loc-search-button')
			.addEventListener('click', handleSearch);

		// Handle Enter keypress
		document
			.getElementById('custom-loc-search')
			.addEventListener('keypress', function (e) {
				if (e.key === 'Enter') {
					handleSearch();
				}
			});
	}

	function handleSearch() {
		const searchInput = document
			.getElementById('custom-loc-search')
			.value.trim()
			.toLowerCase();

		if (searchInput === '') {
			resetMapView();
			document.querySelector('#pagination-controls').style.display =
				'flex';
			//enablePagination();
			const contentAccordions = document.querySelectorAll('.info-card');
			contentAccordions.forEach((contentAccordion) => {
				if (contentAccordion) {
					contentAccordion.classList.remove('hide-location');
				}
			});
			// if (window.innerWidth < 992) {
			// 	enablePagination();
			// } else {
			// 	disablePagination();
			// }
			return;
		}

		const searchedZipCode = searchInput.match(/\b\d{5}\b/); // Check if input contains a valid zip code format
		const matchingLocations = [];

		searchAndHighlightAccordion(searchInput);

		// if (window.innerWidth > 991) {
		// 	searchAndHighlightAccordion(searchInput);
		// } else {
		// 	disablePagination();
		// 	console.log('here');
		// 	searchAndHighlightAccordion(searchInput);
		// 	// if (matchingLocations.length > 0) {
		// 	// 	updateInfoCardVisibility(matchingLocations, 'zip');
		// 	// 	updateMap(matchingLocations, 'zip');
		// 	// } else {
		// 	// 	displayNoMatchMessage();
		// 	// }
		// }
	}
	function searchAndHighlightAccordion(searchInput) {
		const searchText = searchInput.toLowerCase();
		const matchingLocations = [];
		if (isNaN(searchText) && searchText.trim() !== '') {
			const accordionHeaders = document.querySelectorAll(
				'.accordion-group .accordion-header button'
			);
			const allContents = document.querySelectorAll(
				'.accordion-group .accordion-content'
			);
			allContents.forEach((content) => {
				content.classList.remove('active');
			});

			accordionHeaders.forEach((button) => {
				const headerText = button.textContent.trim().toLowerCase();
				//console.log('search text: ', searchText);
				//console.log('header text: ', headerText);
				if (headerText.includes(searchText)) {
					//console.log('matches');
					const accordionGroup = button.closest('.accordion-group');
					const accordionContent =
						accordionGroup.querySelector('.accordion-content');
					accordionContent.classList.add('active');
					const infoCards =
						accordionContent.querySelectorAll('.info-card');
					infoCards.forEach((card) => {
						//const zip = String(card.getAttribute('data-zip'));
						const title = String(card.getAttribute('data-title'));
						if (title !== null) {
							card.classList.remove('hide-location');
							matchingLocations.push(title);
						}
					});
				}
			});
			const cityKeys = Object.keys(cityZipMap).filter((key) =>
				key.toLowerCase().includes(searchText)
			);

			//console.log('cit keys ', cityKeys);
			//const zips = cityKeys.map((key) => String(cityZipMap[key]));
			//console.log('zips ', zips);

			cityKeys.forEach((key) => {
				const contentAccordions = document.querySelectorAll(
					`[data-title="${key}"]`
				);

				contentAccordions.forEach((contentAccordion) => {
					const conncordionHeader = contentAccordion
						.querySelector('h3')
						?.textContent.trim()
						.toLowerCase();
					if (
						conncordionHeader &&
						conncordionHeader.includes(searchText)
					) {
						const accordionContent =
							contentAccordion.closest('.accordion-content');
						if (accordionContent) {
							accordionContent.classList.add('active');
						}
					}
				});

				const location = String(key);
				if (location) {
					matchingLocations.push(location);
				}
			});

			//console.log(matchingLocations);
			if (matchingLocations.length > 0) {
				updateMap(matchingLocations, 'titles');
				updateInfoCardVisibility(matchingLocations, 'titles');
				scrollToFirstActiveAccordion(
					'.accordion-group .accordion-content.active'
				);
			} else {
				displayNoMatchMessage();
			}
		} else {
			const matchingCards = document.querySelectorAll(
				`.info-card[data-zip="${searchText}"]`
			);
			matchingCards.forEach((card) => {
				if (card) {
					const accordionGroup = card.closest('.accordion-group');
					const accordionContent =
						accordionGroup.querySelector('.accordion-content');
					accordionContent.classList.add('active');
					card.classList.remove('hide-location');
					matchingLocations.push(searchText);
				}
			});

			if (matchingLocations.length > 0) {
				updateMap(matchingLocations, 'zip');
				updateInfoCardVisibility(matchingLocations, 'zip');
				scrollToFirstActiveAccordion(
					'.accordion-group .accordion-content.active'
				);
			} else {
				displayNoMatchMessage();
			}
		}
	}

	function scrollToFirstActiveAccordion(target) {
		const container = document.querySelector(
			'.block-location-finder-results__list'
		);
		const activeAccordion = container.querySelector(target);
		if (activeAccordion) {
			const accordionGroup = activeAccordion.closest('.accordion-group');
			const containerTop = container.offsetTop;
			const accordionTop = accordionGroup.offsetTop;

			const scrollPosition = accordionTop - containerTop;
			container.scrollTo({
				top: scrollPosition,
				behavior: 'smooth',
			});
		}
	}
	function updateMap(locations, type) {
		markers.forEach((marker) => marker.setMap(null));
		markers = [];
		const _locations = locations;
		//console.log('matching locations: ', _locations);

		let locationSet = new Set(locations.map(Number));
		let filteredLocations;
		if (type === 'titles') {
			locationSet = new Set(locations.map(String));

			filteredLocations = zipCodes.filter((zipCode) =>
				locationSet.has(String(zipCode.title))
			);
		} else if (type === 'zip') {
			locationSet = new Set(locations.map(Number));

			filteredLocations = zipCodes.filter((zipCode) =>
				locationSet.has(Number(zipCode.zip))
			);
		}
		//console.log('location set: ', locationSet);

		if (filteredLocations.length === 1) {
			// Center map and add marker for a single location
			const location = filteredLocations[0];
			map.setCenter({ lat: location.lat, lng: location.lng });
			map.setZoom(12); // Adjust this zoom level as needed
			addMarker(location.zip, location.lat, location.lng, location.title);
		} else {
			const bounds = new google.maps.LatLngBounds();
			filteredLocations.forEach((location) => {
				addMarker(
					location.zip,
					location.lat,
					location.lng,
					location.title
				); // Add marker
				bounds.extend(
					new google.maps.LatLng(location.lat, location.lng)
				);
			});
			map.fitBounds(bounds); // Fit the map to the bounds
		}
		// if (locations.length === 1) {
		// 	// If there's only one location, center the map on it and set a specific zoom level
		// 	const location = locations[0];
		// 	map.setCenter({ lat: location.lat, lng: location.lng });
		// 	map.setZoom(12); // Adjust this zoom level as needed
		// 	addMarker(location.zip, location.lat, location.lng); // Add marker for the single location
		// } else {
		// 	const bounds = new google.maps.LatLngBounds();
		// 	locations.forEach((location) => {
		// 		addMarker(location.zip, location.lat, location.lng); // Add marker for each location
		// 		bounds.extend(
		// 			new google.maps.LatLng(location.lat, location.lng)
		// 		);
		// 	});
		// 	if (markers.length > 0) {
		// 		map.fitBounds(bounds); // Fit the map only if there are markers
		// 	}
		// }

		updateInfoCardVisibility(_locations);

		document.querySelector(
			'.block-location-finder-results__extended-message'
		).style.display = 'none';
		document.body.classList.remove('no-match');
	}

	function displayNoMatchMessage(searchTerm) {
		const message = `No results found for "${searchTerm}". Please reset or adjust your search.`;
		document.querySelector('.empty-message').textContent = message;
		document.querySelector(
			'.block-location-finder-results__extended-message'
		).style.display = 'block';
		document.body.classList.add('no-match');
	}

	document
		.querySelector('.reset-map')
		.addEventListener('click', resetMapView);

	function resetMapView() {
		document.getElementById('custom-loc-search').value = '';
		// Clear existing markers
		markers.forEach((marker) => marker.setMap(null));
		markers = [];

		// Reset the map to the initial default center and zoom level
		map.setCenter({ lat: 37.774929, lng: -122.419418 }); // Default center (e.g., San Francisco)
		map.setZoom(8); // Default zoom level

		// eslint-disable-next-line no-shadow
		const venueZipCodes = zipCodes.map((card) => {
			return card.zip;
		});

		// Create a set of the venue zip codes for quick lookup
		const venueZipSet = new Set(venueZipCodes);

		// Re-add markers only for zip codes that exist in the venue zip set
		const bounds = new google.maps.LatLngBounds();
		zipCodes.forEach((location) => {
			if (venueZipSet.has(location.zip)) {
				// Only add markers for matching ZIP codes

				addMarker(
					location.zip,
					location.lat,
					location.lng,
					location.title
				); // Pass lat and lng separately
				bounds.extend(
					new google.maps.LatLng(location.lat, location.lng)
				);
			}
		});

		// Fit the map to the bounds of the newly added markers
		if (markers.length > 0) {
			map.fitBounds(bounds); // Fit the map only if there are markers
		}

		updateInfoCardVisibility(venueZipCodes);
		document.querySelector(
			'.block-location-finder-results__extended-message'
		).style.display = 'none';
		document.body.classList.remove('no-match');
	}

	function addMarker(zip, lat, lng, title) {
		const customIconUrl =
			'/wp-content/themes/propel/images/custom-marker.svg'; // Replace with your custom icon URL
		const customHoverIconUrl =
			'/wp-content/themes/propel/images/custom-marker-hover-new.svg'; // Hover icon URL

		const marker = new google.maps.Marker({
			position: { lat, lng },
			map,
			icon: {
				url: customIconUrl, // URL of your custom icon
				scaledSize: new google.maps.Size(60, 60), // Size of the icon in pixels
			},
		});
		marker.title = title; // Set the title for the marker
		markers.push(marker); // Store the marker in your markers array

		// Set up hover effect for marker to card
		marker.addListener('mouseover', function () {
			const card = document.querySelector(`[data-title='${title}']`);
			if (card) card.classList.add('hover');
			marker.setIcon({
				url: customHoverIconUrl,
				scaledSize: new google.maps.Size(77, 77),
			});
		});

		marker.addListener('mouseout', function () {
			const card = document.querySelector(`[data-title='${title}']`);
			if (card) card.classList.remove('hover');
			marker.setIcon({
				url: customIconUrl,
				scaledSize: new google.maps.Size(60, 60),
			});
		});

		// Set up hover effect for info-card to marker
		const infoCard = document.querySelector(`[data-title='${title}']`);
		if (infoCard) {
			infoCard.addEventListener('mouseenter', () => {
				marker.setIcon({
					url: customHoverIconUrl,
					scaledSize: new google.maps.Size(77, 77),
				});
			});

			infoCard.addEventListener('mouseleave', () => {
				marker.setIcon({
					url: customIconUrl,
					scaledSize: new google.maps.Size(60, 60),
				});
			});
		}
	}

	// Add hover effect from card to marker
	document.querySelectorAll('.info-card').forEach((card) => {
		const title = decodeHtml(card.getAttribute('data-title'));
		let isHovered = false; // Track hover state for the card
		const customIconUrl =
			'/wp-content/themes/propel/images/custom-marker.svg'; // Replace with your custom icon URL
		const customHoverIconUrl =
			'/wp-content/themes/propel/images/custom-marker-hover.svg'; // Hover icon URL

		card.addEventListener('mouseenter', function () {
			if (!isHovered) {
				// Only log if the card wasn't already hovered
				isHovered = true;
				//console.log(`Hovering over card with zip ${zip}.`);

				// Find the marker with matching title and trigger hover effect
				const matchingMarker = markers.find(
					(marker) => decodeHtml(marker.title) === title
				);
				if (matchingMarker) {
					//console.log(`Found matching marker for title ${title}.`); // Debug log
					matchingMarker.setIcon({
						url: customHoverIconUrl,
						scaledSize: new google.maps.Size(77, 77),
					});
					//console.log(`Hovered on marker for zip ${zip}.`);
				} else {
					//console.log(`No matching marker found for zip ${zip}.`); // Debug log
				}
			}
		});

		card.addEventListener('mouseleave', function () {
			if (isHovered) {
				// Only log if the card was actually hovered
				isHovered = false;
				// console.log(`Mouseout from card with zip ${zip}.`);

				// Reset the marker icon back to the original
				const matchingMarker = markers.find(
					(marker) => decodeHtml(marker.title) === title
				);
				if (matchingMarker) {
					matchingMarker.setIcon({
						url: customIconUrl,
						scaledSize: new google.maps.Size(60, 60),
					});
					// console.log(`Reset marker icon for zip ${zip}.`); // Debug log
				}
			}
		});
	});

	window.onload = initMap;

	// Next Code

	const accordionHeaders = document.querySelectorAll('.accordion-header');

	accordionHeaders.forEach((header) => {
		header.addEventListener('click', function () {
			const content = this.nextElementSibling;
			content.classList.toggle('active');
			if (content.classList.contains('active')) {
				const infoCards = content.querySelectorAll('.info-card');
				infoCards.forEach((card) => {
					card.classList.remove('hide-location');
				});
			}
		});
	});

	const cards = document.querySelectorAll('.info-card');
	const perPage = 12;
	let currentPage = 1;
	const totalCards = cards.length;
	const totalPages = Math.ceil(totalCards / perPage);

	const renderCards = () => {
		cards.forEach((card, index) => {
			if (
				index >= (currentPage - 1) * perPage &&
				index < currentPage * perPage
			) {
				card.style.display = '';
			} else {
				card.style.display = 'none';
			}
		});
	};
	const scrollToResults = () => {
		const resultsContainer = document.querySelector(
			'.block-location-finder-results__list'
		);
		if (resultsContainer) {
			const headerHeight = document.querySelector('header')
				? document.querySelector('.main-header').offsetHeight
				: 0;
			window.scrollTo({
				top: resultsContainer.offsetTop - headerHeight, // Subtract header height for offset
				behavior: 'smooth', // Smooth scrolling
			});
		}
	};

	const renderPaginationControls = () => {
		const controlsContainer = document.getElementById(
			'pagination-controls'
		);
		controlsContainer.innerHTML = '';

		const createButton = (
			text,
			isActive = false,
			isDisabled = false,
			className
		) => {
			const button = document.createElement('button');
			button.textContent = text;
			button.classList.add('pagination-button', className);
			if (isActive) button.classList.add('active');
			if (isDisabled) button.classList.add('disabled');
			return button;
		};

		// Add "Previous" button
		const prevButton = createButton(
			'',
			false,
			false,
			'pagination-button--prev'
		);
		prevButton.addEventListener('click', () => {
			if (currentPage > 1) {
				currentPage--;
				renderCards();
				renderPaginationControls();
			}
		});
		controlsContainer.appendChild(prevButton);

		// Create page buttons with ellipsis for large ranges
		for (let i = 1; i <= totalPages; i++) {
			if (
				i === 1 ||
				i === totalPages ||
				(i >= currentPage - 1 && i <= currentPage + 1)
			) {
				const button = createButton(
					i,
					i === currentPage,
					false,
					`page-no-${i}`
				);
				button.addEventListener('click', () => {
					currentPage = i;
					renderCards();
					renderPaginationControls();
					scrollToResults();
				});
				controlsContainer.appendChild(button);
			} else if (
				(i === 2 && currentPage > 3) || // Add ellipsis after the first page
				(i === totalPages - 1 && currentPage < totalPages - 2) // Add ellipsis before the last page
			) {
				const ellipsis = document.createElement('span');
				ellipsis.textContent = '...';
				ellipsis.classList.add('pagination-ellipsis');
				controlsContainer.appendChild(ellipsis);
			}
		}

		// Add "Next" button
		const nextButton = createButton(
			'',
			false,
			false,
			'pagination-button--next'
		);
		nextButton.addEventListener('click', () => {
			if (currentPage < totalPages) {
				currentPage++;
				renderCards();
				renderPaginationControls();
				scrollToResults();
			}
		});
		controlsContainer.appendChild(nextButton);
	};

	const enablePagination = () => {
		renderCards();
		renderPaginationControls();
		scrollToResults();
	};

	const disablePagination = () => {
		cards.forEach((card) => (card.style.display = ''));
		document.getElementById('pagination-controls').innerHTML = '';
	};

	if (window.innerWidth < 992) {
		//enablePagination();
	} else {
		//disablePagination();
	}

	//console.log(markers);
}

window.addEventListener('google-maps-loaded', initLocationFinder);
